module.exports = __webpack_public_path__ + "static/media/Icon1.84bc2f22.png";